"use client";

import { c as _c } from "react/compiler-runtime";
import { Box } from "@mui/material";
import React, { useState } from "react";
import { Group, Panel, type PanelProps } from "react-resizable-panels";
import { ResizeHandle } from "#/shared/ui/atoms/ResizeHandle";
export type SplitPanelsLayoutProps = {
  component?: "div" | "section" | "main" | "article" | "aside";
  TopLeft: PanelContent;
  TopRight: PanelContent;
  BottomLeft: PanelContent;
  BottomRight: PanelContent;
};
export type PanelContentProps = {
  verticalSize?: number;
};
type PanelContent = React.FC<PanelContentProps>;
type ControlledPanelProps = PanelProps & {
  Child: PanelContent;
};
const ControlledPanel: React.FC<ControlledPanelProps> = t0 => {
  const $ = _c(10);
  let Child;
  let restProps;
  if ($[0] !== t0) {
    ({
      Child,
      ...restProps
    } = t0);
    $[0] = t0;
    $[1] = Child;
    $[2] = restProps;
  } else {
    Child = $[1];
    restProps = $[2];
  }
  const [size, setSize] = useState(0);
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = size_0 => {
      setSize(size_0.asPercentage);
    };
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== Child || $[5] !== size) {
    t2 = <Child verticalSize={size} />;
    $[4] = Child;
    $[5] = size;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== restProps || $[8] !== t2) {
    t3 = <Panel onResize={t1} {...restProps}>{t2}</Panel>;
    $[7] = restProps;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};
export const SplitPanelsLayout: React.FC<SplitPanelsLayoutProps> = t0 => {
  const $ = _c(24);
  const {
    component: t1,
    TopLeft,
    TopRight,
    BottomLeft,
    BottomRight
  } = t0;
  const component = t1 === undefined ? "div" : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      height: "calc(100vh - 57px)",
      width: "100vw",
      px: 1,
      pb: 1,
      overflow: "hidden"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== TopLeft) {
    t3 = <ControlledPanel defaultSize={15} Child={TopLeft} />;
    $[1] = TopLeft;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ResizeHandle />;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== BottomLeft) {
    t5 = <ControlledPanel defaultSize={30} Child={BottomLeft} />;
    $[4] = BottomLeft;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t3 || $[7] !== t5) {
    t6 = <Panel defaultSize={60}><Group autoSave="main-vertical-left" orientation="vertical">{t3}{t4}{t5}</Group></Panel>;
    $[6] = t3;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <ResizeHandle />;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== TopRight) {
    t8 = <ControlledPanel defaultSize={80} Child={TopRight} />;
    $[10] = TopRight;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <ResizeHandle />;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== BottomRight) {
    t10 = <ControlledPanel defaultSize={30} Child={BottomRight} />;
    $[13] = BottomRight;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t10 || $[16] !== t8) {
    t11 = <Panel defaultSize={40}><Group autoSave="main-vertical-right" orientation="vertical">{t8}{t9}{t10}</Group></Panel>;
    $[15] = t10;
    $[16] = t8;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t11 || $[19] !== t6) {
    t12 = <Group autoSave="main-horizontal" orientation="horizontal">{t6}{t7}{t11}</Group>;
    $[18] = t11;
    $[19] = t6;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== component || $[22] !== t12) {
    t13 = <Box component={component} sx={t2}>{t12}</Box>;
    $[21] = component;
    $[22] = t12;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  return t13;
};